export default {
    change_password_title: "Change Password",
    change_password_old_password: "Old Password",
    change_password_new_password: "New Password",
    change_password_changed: "Password changed",
    change_password_incorrect: "Incorrect username or password",
    change_password_limit_exceeded: "Attempt limit exceeded, please try after some time"
};

